import { render, staticRenderFns } from "./money_rank.vue?vue&type=template&id=4e791678&scoped=true&"
import script from "./money_rank.vue?vue&type=script&lang=js&"
export * from "./money_rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e791678",
  null
  
)

export default component.exports